import { useCallback, useEffect } from 'react';
import './ShortcutsOverlay.css';

const FIXED_SHORTCUTS = [
  { chord: '[', description: 'Contraer / expandir menú' },
  { chord: '⌘K', description: 'Buscar / paleta de comandos' },
  { chord: '?', description: 'Esta ayuda de atajos' },
];

export default function ShortcutsOverlay({ open, onClose, groups }) {
  const handleKeyDown = useCallback(
    (e) => {
      if (!open) return;
      if (e.key === 'Escape') {
        // Swallow Escape so only the topmost layer closes. Listening in the
        // CAPTURE phase + stopPropagation prevents the event from reaching
        // document-level Escape listeners underneath (e.g. an open Modal),
        // so this overlay closes without also closing the layer behind it.
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }
    },
    [open, onClose],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, true);
    return () => document.removeEventListener('keydown', handleKeyDown, true);
  }, [handleKeyDown]);

  if (!open) return null;

  // Collect nav items that have a shortcut
  const navItems = (groups || []).flatMap((g) =>
    (g.items || []).filter((item) => item.shortcut),
  );

  return (
    <div className="sh-overlay__scrim" onClick={onClose}>
      <div
        className="sh-overlay__panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="sh-overlay__title"
      >
        <div className="sh-overlay__header">
          <h2 id="sh-overlay__title" className="sh-overlay__title">
            Atajos de teclado
          </h2>
          <button
            className="sh-overlay__close"
            onClick={onClose}
            aria-label="Cerrar ayuda de atajos"
          >
            ✕
          </button>
        </div>

        <div className="sh-overlay__body">
          {navItems.length > 0 && (
            <section className="sh-overlay__section">
              <h3 className="sh-overlay__section-title">Navegación</h3>
              <ul className="sh-overlay__list">
                {navItems.map((item) => (
                  <li key={item.path} className="sh-overlay__row">
                    <span className="sh-overlay__row-label">
                      Ir a {item.label}
                    </span>
                    <span
                      className="sh-overlay__row-chord"
                      aria-label={`Atajo G ${item.shortcut}`}
                    >
                      <kbd>G</kbd>
                      <kbd>{item.shortcut}</kbd>
                    </span>
                  </li>
                ))}
              </ul>
            </section>
          )}

          <section className="sh-overlay__section">
            <h3 className="sh-overlay__section-title">General</h3>
            <ul className="sh-overlay__list">
              {FIXED_SHORTCUTS.map(({ chord, description }) => (
                <li key={chord} className="sh-overlay__row">
                  <span className="sh-overlay__row-label">{description}</span>
                  <span
                    className="sh-overlay__row-chord"
                    aria-label={`Atajo ${chord}`}
                  >
                    <kbd>{chord}</kbd>
                  </span>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
